import { PrivateRoute } from 'shared/components/privateRoute/PrivateRoute';
import DefaultLayout from 'layouts/DefaultLayout';
import { PlantDesignApplicantDetails } from 'plantDesign/pages/applicantDetails/PlantDesignApplicantDetails';
import { PlantDesignBeforeYouStart } from 'plantDesign/pages/beforeYouStart/PlantDesignBeforeYouStart';
import { PlantDesignConfirmation } from 'plantDesign/pages/confirmation/PlantDesignConfirmation';
import { PlantDesignDeclaration } from 'plantDesign/pages/declaration/PlantDesignDeclarations';
import { DesignerVerifierDetails } from 'plantDesign/pages/designerVerifierDetails/DesignerVerifierDetails';
import { PlantDesignRegistrationHolder } from 'plantDesign/pages/designRegistrationHolder/PlantDesignRegistrationHolder';
import { AddDrawing } from 'plantDesign/pages/drawingsAndTechDetails/AddDrawing';
import { AddTechStandard } from 'plantDesign/pages/drawingsAndTechDetails/AddTechStandard';
import { DrawingsAndTechDetails } from 'plantDesign/pages/drawingsAndTechDetails/DrawingsAndTechDetails';
import { PlantDesignFees } from 'plantDesign/pages/fees/PlantDesignFees';
import { PlantDesignDetails } from 'plantDesign/pages/plantDesignDetails/PlantDesignDetails';
import { PlantDesignReview } from 'plantDesign/pages/review/PlantDesignReview';
import { PlantDesignWhatYouNeed } from 'plantDesign/pages/whatYouNeed/PlantDesignWhatYouNeed';
import { useSelector } from 'react-redux';
import { Navigate, Route } from 'react-router-dom';
import { ResumeApplication } from 'shared/pages/resumeApplication/ResumeApplication';
import { PlantDesignConstants } from 'plantDesign/constants/plantDesignConstants';

const { PagePath } = require('shared/constants/pagePath');
const { PageLayout } = require('layouts/PageLayout');
const React = require('react');

const PlantDesignRoutes = (props) => {
  const skipBeforeYouStartPage = useSelector((state) => state?.plantDesignApplication?.skipBeforeYouStartPage);

  return (
    <>
      <Route
        path="/design"
        element={
          <Navigate
            replace
            to={skipBeforeYouStartPage ? PagePath.plantDesignWhatYouNeed : PagePath.plantDesignBeforeYouStart}
          />
        }
      />
      <Route
        path={PagePath.plantDesignBeforeYouStart}
        element={
          <DefaultLayout className="greyBackground">
            <PlantDesignBeforeYouStart />
          </DefaultLayout>
        }
      />
      <Route
        path={PagePath.plantDesignWhatYouNeed}
        element={
          <PageLayout title="What you need" label="Plant design registration">
            <PlantDesignWhatYouNeed />
          </PageLayout>
        }
      />
      <Route
        path={PagePath.plantDesignApplicantDetails}
        element={
          <PrivateRoute storeRedirect storeCurrentPath>
            <PageLayout title="Your details" label="Plant design registration">
              <PlantDesignApplicantDetails />
            </PageLayout>
          </PrivateRoute>
        }
      />
      <Route
        path={PagePath.plantDesignRegistrationHolder}
        element={
          <PrivateRoute storeCurrentPath>
            <PageLayout title="Registration holder details" label="Plant design registration">
              <PlantDesignRegistrationHolder />
            </PageLayout>
          </PrivateRoute>
        }
      />
      <Route
        path={PagePath.plantDesignDetails}
        element={
          <PrivateRoute storeCurrentPath>
            <PageLayout title="Plant Design Details" label="Plant design registration">
              <PlantDesignDetails />
            </PageLayout>
          </PrivateRoute>
        }
      />
      <Route
        path={PagePath.plantDesignDrawingAndTechnicalDetails}
        element={
          <PrivateRoute storeCurrentPath>
            <PageLayout title="Drawing and technical standards" label="Plant design registration">
              <DrawingsAndTechDetails />
            </PageLayout>
          </PrivateRoute>
        }
      />
      <Route
        path={PagePath.plantDesignAddDrawing}
        element={
          <PrivateRoute storeCurrentPath>
            <PageLayout title="Add drawing" label="Plant design registration">
              <AddDrawing />
            </PageLayout>
          </PrivateRoute>
        }
      />
      <Route
        path={PagePath.plantDesignAddTechStandard}
        element={
          <PrivateRoute storeCurrentPath>
            <PageLayout title="Add technical standards" label="Plant design registration">
              <AddTechStandard />
            </PageLayout>
          </PrivateRoute>
        }
      />
      <Route
        path={PagePath.plantDesignDesignerVerifierDetails}
        element={
          <PrivateRoute storeCurrentPath>
            <PageLayout title="Designer and design verifier details" label="Plant design registration">
              <DesignerVerifierDetails />
            </PageLayout>
          </PrivateRoute>
        }
      />
      <Route
        path={PagePath.plantDesignDeclaration}
        element={
          <PrivateRoute storeCurrentPath>
            <PageLayout title="Declaration" label="Plant design registration">
              <PlantDesignDeclaration />
            </PageLayout>
          </PrivateRoute>
        }
      />
      <Route
        path={PagePath.plantDesignConfirmation}
        element={
          <PrivateRoute storeCurrentPath storeRedirect>
            <PageLayout title="Confirmation" label="Plant design registration">
              <PlantDesignConfirmation />
            </PageLayout>
          </PrivateRoute>
        }
      />
      <Route
        path={PagePath.plantDesignReview}
        element={
          <PrivateRoute storeCurrentPath>
            <PageLayout title="Review" label="Plant design registration">
              <PlantDesignReview />
            </PageLayout>
          </PrivateRoute>
        }
      />
      <Route
        path={PagePath.plantDesignFees}
        element={
          <PrivateRoute storeCurrentPath>
            <PageLayout title="Fees" label="Plant design fees">
              <PlantDesignFees />
            </PageLayout>
          </PrivateRoute>
        }
      />
      <Route
        path={PagePath.plantDesignApplicationById}
        element={
          <PrivateRoute storeRedirect>
            <PageLayout>
              <ResumeApplication {...props} licenceType={PlantDesignConstants.licenceType} />
            </PageLayout>
          </PrivateRoute>
        }
      />
    </>
  );
};

export default PlantDesignRoutes;
